import React from "react";

export const InvoiceTemplateContext = React.createContext(null);

export const InvoiceTemplateProvider = props => {
  return (
    <InvoiceTemplateContext.Provider {...props} />
  );
};
